export default __webpack_public_path__ + "static/sliksafe-eb3d4371e3917344efad48536e94f6b0.jpg";